import { ColorBand } from "@/lib/scoring";

const STYLES: Record<ColorBand, { bg: string; text: string; ring: string; dot: string; bar: string; label: string }> = {
  green: {
    bg: "bg-emerald-500/10",
    text: "text-emerald-300",
    ring: "ring-emerald-500/30",
    dot: "bg-emerald-400",
    bar: "bg-emerald-400",
    label: "Green",
  },
  amber: {
    bg: "bg-orange-500/10",
    text: "text-orange-300",
    ring: "ring-orange-500/30",
    dot: "bg-orange-400",
    bar: "bg-orange-400",
    label: "Orange",
  },
  red: {
    bg: "bg-rose-500/10",
    text: "text-rose-300",
    ring: "ring-rose-500/30",
    dot: "bg-rose-400",
    bar: "bg-rose-400",
    label: "Red",
  },
  tbd: {
    bg: "bg-neutral-700/40",
    text: "text-neutral-300",
    ring: "ring-neutral-500/30",
    dot: "bg-neutral-400",
    bar: "bg-neutral-500",
    label: "TBD",
  },
};

export function BandPill({ band, capped }: { band: ColorBand; capped?: boolean }) {
  const s = STYLES[band];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider ring-1 ring-inset ${s.bg} ${s.text} ${s.ring}`}
    >
      <span className={`band-dot ${s.dot}`} />
      {s.label}{capped ? " (cap)" : ""}
    </span>
  );
}

export function BandDot({ band, className = "" }: { band: ColorBand; className?: string }) {
  const s = STYLES[band];
  return <span className={`band-dot ${s.dot} ${className}`} />;
}

export function BandBar({ band, value, max = 100 }: { band: ColorBand; value: number; max?: number }) {
  const s = STYLES[band];
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div className="bar-track w-full">
      <div className={`bar-fill ${s.bar}`} style={{ width: `${pct}%` }} />
    </div>
  );
}

export function bandStyle(band: ColorBand) {
  return STYLES[band];
}
